import { C4ListResponse } from '@domain/interface/c4-list-response';
import { createAction, props } from '@ngrx/store';
import { ProjectDTO, Owner, CustomerDTO } from 'cargo-chief-commons';

export const WORKFLOWS = {
	PROJECTS_LIST: {
		GET: createAction('[Workflows] Get Projects', props<any>()),
		SUCCESS: createAction('[Workflows] Get Projects success', props<C4ListResponse<ProjectDTO>>()),
		FAILURE: createAction(
			'[Workflows] Get Projects failure',
			props<{ payload: { message: string } }>()
		),
	},
	USERS_LIST: {
		SET: createAction('[Workflows UsersList] Set Users List', props<{ usersList: Owner[] }>()),
	},
	SORT: {
		SET: createAction('[SORT] Workflows Set sort', props<{ sort: any[] }>()),
	},
	FILTERS: {
		SET: createAction('[FILTERS] Workflows Set filters', props<{ filters: any[] }>()),
	},
	EDIT_PROJECT: {
		OPEN_DIALOG: createAction(
			'[Workflows EDIT_PROJECT] Open dialog',
			props<{
				projects: any;
				action: string;
				title: string;
				cancelButtonText: string;
				confirmButtonText: string;
				usersList?: any;
				projectAction?: string;
				projectIds?: string[];
			}>()
		),
		UPDATE: createAction('[Workflows UPDATE] Update Projects', props<{ payload: any }>()),
		UPDATE_SUCCESS: createAction(
			'[Workflows UPDATE_SUCCESS] Projects update successful',
			props<{ updatedProjects: Record<string, ProjectDTO> }>()
		),
		UPDATE_FAILED: createAction('[Workflows UPDATE_FAILED] Projects update failed', props<any>()),
		CLOSE: createAction('[Workflows CLOSE] Close update projects dialog', props<any>()),
		UPDATE_DUE_DATE: createAction(
			'[Workflows UPDATE_DUE_DATE] update projects due date',
			props<{ dueDate: Date; projectIds: string[] }>()
		),
		UPDATE_CUSTOMER: createAction(
			'[Workflows UPDATE_CUSTOMER] update projects customer',
			props<{ customerDTO: CustomerDTO; projectIds: string[] }>()
		),
		UPDATE_ASSIGNEE: createAction(
			'[Workflows UPDATE_ASSIGNEE] update projects assignee',
			props<{ assigneeId: number; projectIds: string[] }>()
		),
		UPDATE_OUT_OF_NETWORK: createAction(
			'[Workflows UPDATE_OUT_OF_NETWORK] update projects out of network',
			props<{ sendToOutOfNetworkCarriers: boolean; projectIds: string[] }>()
		),
	},
	ARCHIVE_PROJECTS: {
		ARCHIVE: createAction('[Workflows ARCHIVE] Archive selected projects', props<any>()),
		ARCHIVE_SUCCESS: createAction('[Workflows ARCHIVE_SUCCESS] Projects archived', props<any>()),
		ARCHIVE_FAILED: createAction('[Workflows ARCHIVE_FAILED] Failed to archive projects', props<any>()),
	},
	UPLOAD_PROJECTS: {
		OPEN_DIALOG: createAction(
			'[Workflows UPLOAD_PROJECTS] Open dialog',
			props<{
				dataType: string;
				title: string;
				subtitle: string;
				secondStepTitle: string;
				thirdStepTitle: string;
			}>()
		),
		UPLOAD: createAction('[Workflows UPLOAD] Upload projects', props<any>()),
		SUCCESS: createAction('[Workflows SUCCESS] Projects upload successful', props<any>()),
		FAILURE: createAction('[Workflows FAILURE] Projects upload failed', props<any>()),
		CLOSE: createAction('[Workflows CLOSE] Close dialog', props<any>()),
	},
	CREATE_PROJECT: {
		OPEN_DIALOG: createAction('[Workflows CREATE_PROJECT] Open project dialog', props<any>()),
		SUCCESS: createAction('[Workflows SUCCESS] Project created successfully', props<any>()),
		FAILURE: createAction('[Workflows FAILURE] Failed to create project', props<any>()),
		CLOSE: createAction('[Workflows CLOSE] Close dialog', props<any>()),
	},

	ACTIVE_TAB: {
		SET: createAction('[ACTIVE_TAB] Workflows Set ACTIVE_TAB', props<{ activeTab: string }>()),
	},

	CUSTOM_TAB: {
		GET: createAction('[Workflows CUSTOM TAB] Get Custom Tab', props<any>()),
		DELETE: createAction('[Workflows CUSTOM TAB] Delete Custom Tab', props<any>()),
		DELETE_SUCCESS: createAction('[Workflows CUSTOM TAB] Delete Custom Tab Success', props<any>()),
		SUCCESS: createAction('[Workflows CUSTOM TAB] Get Custom Tab Success', props<any>()),
		FAILURE: createAction(
			'[Workflows CUSTOM TAB]Get Custom Tab Failure',
			props<{ payload: { message: string } }>()
		),
	},
	TABS: {
		SET: createAction('[Workflows TABS] Set tabs', props<{ allTabs: string[] }>()),
	},

	USERS_SORT_AND_FILTERS: {
		GET: createAction('[Workflows TABS] get saved users sorts and filters', props<any>()),
		SUCCESS: createAction('[Workflows TABS] get saved users sorts and filters success', props<any>()),
		FAILURE: createAction('[Workflows TABS] get saved users sorts and filters failure', props<any>()),
		SET: createAction('[Workflows TABS] Set saved custom tabs and filters', props<any>()),
	},

	BA: {
		OPEN_DIALOG: createAction('[Workflows] open BA form dialog', props<any>()),
		CLOSE_DIALOG: createAction('[Workflows] close BA form dialog', props<any>()),
	},

	HISTORICAL_LOADS_COUNT: {
		GET: createAction('[Workflows] Get historical loads count', props<any>()),
		SUCCESS: createAction('[Workflows] Get historical loads success', props<any>()),
		FAILURE: createAction(
			'[Workflows] Get historical loads failure',
			props<{ payload: { message: string } }>()
		),
	},
	ACTIVE_LOADS_COUNT: {
		GET: createAction('[Workflows] Get active loads count', props<any>()),
		SUCCESS: createAction('[Workflows] Get active loads success', props<any>()),
		FAILURE: createAction(
			'[Workflows] Get active loads failure',
			props<{ payload: { message: string } }>()
		),
	},
};
